import { Loader2 } from 'lucide-react'

/**
 * LoadingIndicator - Simple loading spinner with optional text
 *
 * Used at top/bottom of Timeline during lazy loading operations
 *
 * @param {Object} props
 * @param {string} props.text - Optional text to display next to spinner (defaults to "Loading...")
 * @param {string} props.className - Additional CSS classes
 */
export default function LoadingIndicator({ text = 'Loading...', className = '' }) {
  return (
    <div className={`flex items-center justify-center py-8 ${className}`} aria-live="polite" aria-busy="true">
      <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
      <span className="ml-3 text-gray-500">{text}</span>
    </div>
  )
}
